<template>
  <b-container fluid class="p-0 mt-4">
    <b-row>
      <div class="filter-button d-block d-sm-none">
        <b-button class="btn-circle btn-lg" @click="$bvModal.show('bv-modal-filters')">
          <font-awesome-icon icon="filter" />
        </b-button>
      </div>
      <b-modal
        id="bv-modal-filters"
        hide-footer
        class="d-block d-sm-none"
        v-on:show="filter_modal_showed=true"
      >
        <!-- Con filter_modal_showed evitamos mostrar el contenido del modal a
        menos que éste se abra, esto nos vale para no hacer llamadas innecesarias
        a la api -->
        <template slot="modal-title">{{ $t('product_list.filters') }}</template>
        <div class="d-block text-center" v-if="filter_modal_showed">
          <CategorySelector
            :categories="categories"
            :groupedCategories="groupedCategories"
            :selectedCategory="selectedCategory"
            :selectedGroupedCategory="selectedGroupedCategory"
          />
          <BrandSelector
            :source="brandDataSource"
            :categoryUuid="selectedCategory && selectedCategory.uuid"
            :groupedCategoryUuid="selectedGroupedCategory && selectedGroupedCategory.uuid"
            :pharmacyUuid="pharmacyUuid"
            :selectedBrand="brandUuid"
            class="mt-5"
          />
          <hr />
          <FilterProductSelector
            v-on:changeOrder="updateOrder($event)"
            v-on:changePage="updatePage($event)"
            v-on:changeViewType="updateViewType($event)"
            v-bind:filterAllowOrdering="allowOrdering"
            v-bind:filterPerPage="perPage"
            v-bind:filterViewType="viewType"
            v-bind:filterOrderBy="orderBy"
          ></FilterProductSelector>
        </div>
        <b-button class="mt-3 btn-primary-b" block @click="$bvModal.hide('bv-modal-filters')">Close</b-button>
      </b-modal>
      <b-col xs="12" sm="3" class="d-none d-sm-block">
        <CategorySelector
          :categories="categories"
          :groupedCategories="groupedCategories"
          :selectedCategory="selectedCategory"
          :selectedGroupedCategory="selectedGroupedCategory"
        />
        <BrandSelector
          :source="brandDataSource"
          :categoryUuid="selectedCategory && selectedCategory.uuid"
          :groupedCategoryUuid="selectedGroupedCategory && selectedGroupedCategory.uuid"
          :pharmacyUuid="pharmacyUuid"
          :selectedBrand="brandUuid"
          class="mt-5"
        />
      </b-col>
      <b-col xs="12" sm="9" class="mt-4 mt-md-0">
        <ProductsViewer
          :source="drugDataSource"
          :categoryUuid="selectedCategory && selectedCategory.uuid"
          :groupedCategoryUuid="selectedGroupedCategory && selectedGroupedCategory.uuid"
          :brandUuid="brandUuid"
          :pharmacyUuid="pharmacyUuid"
          :filterAllowOrdering="allowOrdering"
          :filterPerPage="perPage"
          :filterViewType="viewType"
          :filterOrderBy="orderBy"
          noneOrderBy="default_description"
        />
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import CategorySelector from "@/components/CategorySelector";
import BrandSelector from "@/components/BrandSelector";
import ProductsViewer from "@/components/ProductsViewer";
import FilterProductSelector from "@/components/FilterProductSelector";

export default {
  components: {
    CategorySelector,
    BrandSelector,
    ProductsViewer,
    FilterProductSelector,
  },
  props: {
    categories: {
      type: Array,
      default: undefined,
    },
    groupedCategories: {
      type: Array,
      default: undefined,
    },
    selectedCategory: {
      type: Object,
      default: undefined,
    },
    selectedGroupedCategory: {
      type: Object,
      default: undefined,
    },
    brandUuid: String,
    pharmacyUuid: String,
    drugSource: String,
    brandSource: String,
  },
  data() {
    return {
      brands: [],
      allowOrdering: true,
      orderBy: "highestPrice",
      perPage: "24",
      viewType: "grid",
      // cuando el modal (en modo móvil) de los filtros se abre, esto
      // se coloca a true, lo usamos para cargar el contenido del modal
      // sólo cuando éste se abre, evitamos así que las marcas
      // se carguen dos veces y evitamos así que en móvil se cargen
      // las marcas si no le damos al modal.
      filter_modal_showed: false,
    };
  },
  computed: {
    listType() {
      return this.$route.params.listType;
    },
    drugDataSource() {
      // Primero comprobamos que no sea para la pantalla de la farmacia
      if (this.pharmacyUuid == null) {
        return this.drugSource || "drugs/REQUEST_PHDRUGS";
      } else {
        return "drugs/REQUEST_PHDRUGS";
      }
    },
    brandDataSource() {
      return this.brandSource || "drugs/REQUEST_PHDRUGS_BRANDS";
    },
  },
  methods: {
    updateOrder(value) {
      this.orderBy = value;
    },
    updatePage(value) {
      this.perPage = value;
    },
    updateViewType(value) {
      this.viewType = value;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        product_list: {
          topae: "Top Specialty Drugs",
          topfarma: "Top Medications",
          treatments: "Treatments",
          categories: "Categories",
          pharmacies: "Pharmacies",
          filters: "Filters",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.filter-button {
  position: fixed;
  bottom: 0px;
  right: 0px;
  padding: 20px;
  margin-bottom: 7rem;
  margin-right: 0.5rem;
  z-index: 2;
}
.btn-circle.btn-lg {
  width: 4rem;
  height: 4rem;
  font-size: 2rem;
  border-radius: 4rem;
  min-width: 4rem;
  background-color: $corp-color2;
}

.products-filter {
  border-bottom: 1px solid $grey4-color;
}
</style>
